/* eslint-disable import/no-duplicates */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ANDROID from '../../resources/deviceIcons/Android.png'
import ANDROID_VOC from '../../resources/deviceIcons/Android_VOC.png'
import AVX430 from '../../resources/deviceIcons/AVX430.png'
import AVX460 from '../../resources/deviceIcons/AVX460.png'
import BUTTONS from '../../resources/deviceIcons/Buttons.png'
import CHROMEBOOK from '../../resources/deviceIcons/Chromebook.png'
import CONTENT_DISTRIBUTION from '../../resources/deviceIcons/content_distribution.png'
import ESPRIT from '../../resources/deviceIcons/Esprit.png'
import FURNITURE from '../../resources/deviceIcons/Furniture.png'
import HD_PRO_MINI from '../../resources/deviceIcons/HD_PRO_Mini.png'
import IIYAMA_21 from '../../resources/deviceIcons/IIYAMA_21.png'
import IOS from '../../resources/deviceIcons/iOS.png'
import MOBILE from '../../resources/deviceIcons/Mobile.png'
import SERVER from '../../resources/deviceIcons/Server.png'
import SOUNDBAR from '../../resources/deviceIcons/Soundbar.png'
import TABLET from '../../resources/deviceIcons/Tablet.png'
import TICKET from '../../resources/deviceIcons/Ticket.png'
import TIZEN from '../../resources/deviceIcons/Tizen.png'
import UHD_PRO_1 from '../../resources/deviceIcons/UHD_PRO_1.png'
import UHD_PRO_2 from '../../resources/deviceIcons/UHD_PRO_2.png'
import UHD_PRO_CEC from '../../resources/deviceIcons/UHD_PRO_CEC.png'
import UHD_PRO_MINI from '../../resources/deviceIcons/UHD_PRO_Mini.png'
import UNKNOWN from '../../resources/deviceIcons/Unknown.png'
import UXG from '../../resources/deviceIcons/UXG.png'
import WATCH from '../../resources/deviceIcons/Watch.png'
import WEBOS from '../../resources/deviceIcons/WebOS.png'
import WINDOWS from '../../resources/deviceIcons/Windows.png'

const deviceIconsMap = {
    ANDROID: {
        src: ANDROID,
        name: 'Android',
    },
    ANDROID_VOC: {
        src: ANDROID_VOC,
        name: 'Android VOC',
    },
    AVX430: {
        src: AVX430,
        name: 'AVX430',
    },
    AVX460: {
        src: AVX460,
        name: 'AVX460',
    },
    BUTTONS: {
        src: BUTTONS,
        name: 'Buttons player',
    },
    CHROMEBOOK: {
        src: CHROMEBOOK,
        name: 'Chromebook',
    },
    CONTENT_DISTRIBUTION: {
        src: CONTENT_DISTRIBUTION,
        name: 'Content Distribution',
    },
    ESPRIT: {
        src: ESPRIT,
        name: 'Esprit',
    },
    FURNITURE: {
        src: FURNITURE,
        name: 'Furniture',
    },
    HDPROMINI: {
        src: HD_PRO_MINI,
        name: 'HD PRO Mini',
    },
    IIYAMA21: {
        src: IIYAMA_21,
        name: 'IIYAMA 21',
    },
    IOS: {
        src: IOS,
        name: 'iOS',
    },
    MOBILE: {
        src: MOBILE,
        name: 'Mobile',
    },
    SERVER: {
        src: SERVER,
        name: 'Server',
    },
    SOUNDBAR: {
        src: SOUNDBAR,
        name: 'Soundbar',
    },
    TABLET: {
        src: TABLET,
        name: 'Tablet',
    },
    TICKET: {
        src: TICKET,
        name: 'Ticket',
    },
    TIZEN: {
        src: TIZEN,
        name: 'Tizen',
    },
    UHDPROV1: {
        src: UHD_PRO_1,
        name: 'UHD PRO 1',
    },
    UHDPROV2: {
        src: UHD_PRO_2,
        name: 'UHD PRO 2',
    },
    UHDPROCEC: {
        src: UHD_PRO_CEC,
        name: 'UHD PRO CEC',
    },
    UHDPROMINI: {
        src: UHD_PRO_MINI,
        name: 'UHD PRO Mini',
    },
    UNKNOWN: {
        src: UNKNOWN,
        name: 'Unknown',
    },
    UXG: {
        src: UXG,
        name: 'UXG',
    },
    WATCH: {
        src: WATCH,
        name: 'Watch',
    },
    WEBOS: {
        src: WEBOS,
        name: 'WebOS',
    },
    WINDOWS: {
        src: WINDOWS,
        name: 'Windows',
    },
}

const Img = styled.img`
    height: auto;
    width: 100%;
`

const DeviceIcon = ({ code }) => {
    let icon = deviceIconsMap[code || 'UNKNOWN']
    if (!icon) icon = deviceIconsMap.UNKNOWN
    return <Img src={icon.src} alt={code} title={icon.name} />
}

DeviceIcon.propTypes = {
    code: PropTypes.string,
}

DeviceIcon.defaultProps = {
    code: 'UNKNOWN',
}

export default DeviceIcon
